"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobilePeopleSearch = exports.PeopleSearch = void 0;
var React = require("react");
var peopleSearchStyles = require("@/pages/peopleListing/components/PeopleSearch/PeopleSearch.styles");
var mobilePeopleSearchStyles = require("@/pages/peopleListing/components/PeopleSearch/PeopleSearch.mobile.styles");
var getPeopleSearch = function (styledComponent) {
    var SearchContainer = styledComponent.SearchContainer, FindPeopleLabel = styledComponent.FindPeopleLabel, FindByNameInput = styledComponent.FindByNameInput, SpokenLanguageSelect = styledComponent.SpokenLanguageSelect;
    var peopleSearch = function (props) {
        var nameFilter = props.nameFilter, setNameFilter = props.setNameFilter, languageFilter = props.languageFilter, setLanguageFilter = props.setLanguageFilter, spokenLanguageOptions = props.spokenLanguageOptions, showLabel = props.showLabel, t = props.t;
        var renderSpokenLanguageOptions = function () { return spokenLanguageOptions.map(function (option, i) { return (React.createElement("option", { key: i, value: option.spokenLanguageId }, option.regionalName)); }); };
        var spokenLanguageEventHandler = function (event) {
            return setLanguageFilter(parseInt(event.target.value, 10));
        };
        var nameEventHandler = function (event) {
            return setNameFilter(event.target.value);
        };
        var renderFindPeopleLabel = function (text) { return (React.createElement(FindPeopleLabel, null,
            React.createElement("i", null, text))); };
        return (React.createElement(SearchContainer, null,
            showLabel ? renderFindPeopleLabel(t.findAnAgent) : null,
            React.createElement(FindByNameInput, { placeholder: t.findByFirstLastName, value: nameFilter, onChange: nameEventHandler }),
            React.createElement(SpokenLanguageSelect, { value: languageFilter, onChange: spokenLanguageEventHandler }, renderSpokenLanguageOptions())));
    };
    return peopleSearch;
};
var PeopleSearch = getPeopleSearch(peopleSearchStyles);
exports.PeopleSearch = PeopleSearch;
var MobilePeopleSearch = getPeopleSearch(mobilePeopleSearchStyles);
exports.MobilePeopleSearch = MobilePeopleSearch;
